export default __webpack_public_path__ + "static/media/red-wave-flipped.d2f2a599.svg";